module.exports = __webpack_public_path__ + "img/thumbnail-letstalk.bac8beab.png";